import { CommonFilters } from '../shared/common-types';
import { UrlBuilderUtils } from '../shared/url-builder-utils';
import { updateUrlParams } from '@services/MarppleShop/shared/util';

/**
 * 필터 상태를 관리하는 매니저
 */
export class FilterManager<TFilters extends CommonFilters = CommonFilters> {
  private filters: TFilters;

  constructor(
    filters: TFilters | undefined,
    private readonly defaultFilters: TFilters
  ) {
    // 값이 없으면 기본값으로 초기화
    this.filters = filters ?? defaultFilters;
  }

  setFilters(filters: Partial<TFilters>): this {
    this.filters = { ...this.filters, ...filters };
    return this;
  }

  getFilters(): TFilters {
    return this.filters;
  }

  clearFilters(): this {
    this.filters = { ...this.defaultFilters };
    return this;
  }

  hasFilters(): boolean {
    const keys = Object.keys(this.filters) as (keyof TFilters)[];
    return keys.some((key) => this.filters[key] !== undefined && this.filters[key] !== null);
  }

  /**
   * 상품 목록 페이지 URL 생성 (필터 + 정렬)
   */
  buildProductsUrl(
    baseUrl: string,
    sort?: string,
    additionalParams?: Record<string, string | undefined>,
  ): string {
    const commonParams = UrlBuilderUtils.buildProductsParams(this.filters, sort);
    const allParams = additionalParams ? { ...commonParams, ...additionalParams } : commonParams;
    return updateUrlParams(baseUrl, allParams);
  }

  reset(): this {
    this.filters = { ...this.defaultFilters };
    return this;
  }
}
